// Auto-generated! Please DO NOT EDIT!

export type BNApiResourceName =
  | 'account'
  | 'auth_external_token'
  | 'auth_request'
  | 'badge'
  | 'ban'
  | 'base_task'
  | 'bound_form'
  | 'calendar_sync_event'
  | 'card'
  | 'category'
  | 'certificate'
  | 'channel'
  | 'coach_history'
  | 'coach_task'
  | 'complaint'
  | 'conference'
  | 'coupon'
  | 'course'
  | 'diary'
  | 'edition'
  | 'event'
  | 'favorite'
  | 'file'
  | 'follower'
  | 'form'
  | 'goal'
  | 'invite'
  | 'link'
  | 'material'
  | 'membership'
  | 'message_profile'
  | 'metrics'
  | 'offer'
  | 'payment'
  | 'perk'
  | 'post'
  | 'program'
  | 'questionnaire'
  | 'refund'
  | 'reward'
  | 'reward_profile'
  | 'scheduled_notification'
  | 'session'
  | 'session_note'
  | 'subgoal'
  | 'subtenant'
  | 'task'
  | 'tenant'
  | 'tier'
  | 'used_coupon'
  | 'user'
  | 'user_contact'
  | 'user_questionnaire'
  | 'user_reward';

export const BN_API_RESOURCE_NAMES: Set<BNApiResourceName> = new Set([
  'account',
  'auth_external_token',
  'auth_request',
  'badge',
  'ban',
  'base_task',
  'bound_form',
  'calendar_sync_event',
  'card',
  'category',
  'certificate',
  'channel',
  'coach_history',
  'coach_task',
  'complaint',
  'conference',
  'coupon',
  'course',
  'diary',
  'edition',
  'event',
  'favorite',
  'file',
  'follower',
  'form',
  'goal',
  'invite',
  'link',
  'material',
  'membership',
  'message_profile',
  'metrics',
  'offer',
  'payment',
  'perk',
  'post',
  'program',
  'questionnaire',
  'refund',
  'reward',
  'reward_profile',
  'scheduled_notification',
  'session',
  'session_note',
  'subgoal',
  'subtenant',
  'task',
  'tenant',
  'tier',
  'used_coupon',
  'user',
  'user_contact',
  'user_questionnaire',
  'user_reward',
]);
